import { FunctionComponent } from 'react'
import styled, { css } from 'styled-components'

const StyledDivider = styled.div`
  ${({
    theme: {
      colors: { strokeWeak },
    },
  }) => css`
    background-color: ${strokeWeak};
    width: 1px;
    height: 18px;
  `}
`

const Divider: FunctionComponent = () => <StyledDivider />

export default Divider
